export const TEXTS = {
    METHOD_COUNT: `+ {0}`,
    VIEW_ALL_PREFERRED_METHODS: "View all preferred methods",
};
